import { faChevronLeft, faChevronRight, faCircleXmark, faPlus, faTrashCan, faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useRef, useState } from 'react';
import Docmnt from '../../../../assets/images/google-docs.png';
import { MultiSelect } from 'react-multi-select-component';
import { Modal, Button } from 'react-bootstrap';
import Autosuggest from 'react-autosuggest';
import { withRFSToken } from '../../../../Services/axios.js';
import { STATIONGRID, GETSCHEDULEDTRUCKS, TRUCKERRATELIST } from '../../../../Utils/conts';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import AddStation from '../../../../Components/common/AddStation';
import AddStationAddress from '../../../../Components/common/AddStationAddress';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { forEach } from 'lodash';

const TruckOrderOne = ({ formData, onFormDataChange }) => {
  const [frequentBooking, setFrequentBooking] = useState('O');
  const [bookingTruck, setBookingTruck] = useState({ bookingTruck_type: 'existing' });
  const [bookingTruckList, setBookingTruckList] = useState();
  const [value, setValue] = useState('');
  const [suggestionsBp, setSuggestionsBp] = useState([]);
  const [bpaddress, setBpaddress] = useState(null);
  const [stationData, setStationData] = useState({});
  const [addressType, setAddressType] = useState('');
  const [showAddButton, setShowAddButton] = useState(false);
  const [showAddAddressButton, setShowAddAddressButton] = useState(false);
  const [showAddAddressButton2, setShowAddAddressButton2] = useState(false);
  const [valueOffpoint, setValueOffpoint] = useState('');
  const [suggestionsOffpoint, setSuggestionsOffpoint] = useState([]);
  const [selectedOffpoint, setSelectedOffpoint] = useState(null);
  const [showAddButtonOffpoint, setShowAddButtonOffpoint] = useState(false);
  const [selectedBoardpoint, setSelectedBoardpoint] = useState(null);
  const [hoc_selectedBoardpoint, hoc_setSelectedBoardpoint] = useState(null);
  const [selectedOffpointId, setSelectedOffpointId] = useState(null);
  const [hoc_selectedOffpointId, hoc_setSelectedOffpointId] = useState(null);
  const [fetchStation, setFetchStation] = useState([]);
  const [boardPoint, setBoardpoint] = useState([]);
  const [hoc_boardPoint, hoc_setBoardpoint] = useState([]);
  const [bpAddress, setBpAddress] = useState([]);
  const [hoc_bpaddress, hoc_setBpaddress] = useState([]);
  const [offpoint, setOffpoint] = useState([]);
  const [truckList, setTruckList] = useState([]);
  const [showAddStation, setShowAddStation] = useState(false)
  const [selectedBoardPointAddress, setSelectedBoardPointAddress] = useState([]);
  const [hoc_selectedBoardPointAddress, hoc_setSelectedBoardPointAddress] = useState([]);
  const [offPoint, setOffPoint] = useState([]);
  const [hoc_offPoint, hoc_setOffPoint] = useState([]);
  const [selectedOffPointAddress, setSelectedOffPointAddress] = useState([]);
  const [hoc_selectedOffPointAddress, hoc_setSelectedOffPointAddress] = useState([]);
  const [offPointAddress, setOffPointAddress] = useState([]);
  const [hoc_offPointAddress, hoc_setOffPointAddress] = useState([]);
  const [localFormData, setLocalFormData] = useState({
    departure_date: '',
    travel_time: '',
    start_date: '',
    end_date: '',
    departure_time: '',
    bookingtruck_date_id: '',
    truck_type: 'B',
    bookingTruck_type: 'E',
    booking_type: '',
    existing_date: '',
    bookingtruck_id: '',
    hoc_movement_type: '',
    hoc_date: '',
    hoc_time: '',
    new_movement_type: '',
    bookingtruck_no: '',
    new_board_point: '',
    new_board_address: '',
    new_off_point: '',
    new_off_address: '',
    hoc_board_point: '',
    hoc_board_address: '',
    hoc_off_point: '',
    hoc_off_address: '',
    boardpoint: '',
    new_board_point_name: '',
    new_board_address_name: '',
    new_off_point_name: '',
    new_off_address_name: '',
    hoc_board_point_name: '',
    hoc_board_address_name: '',
    hoc_off_point_name: '',
    hoc_off_address_name: '',
    trip_type: 'O',
    new_date: '',
    new_time: '',
    selected_days: [],
    departure_date: '',
    departure_time: '',
    board_point: '',
    off_point: '',
    boardpoint_name: '',
    boardpoint_address_name: '',
    offpoint_name: '',
    offpoint_address_name: '',
    hoc_boardpoint: '',
    hoc_boardpoint_name: '',
    hoc_boardpoint_address: '',
    hoc_boardpoint_address_name: '',
    hoc_offpoint: '',
    hoc_offpoint_name: '',
    hoc_offpoint_address: '',
    hoc_offpoint_address_name: '',
    selected_days: '',
    hoc_bookingtruck_no: '',
    hoc_trip_type: '',
    hoc_departure_date: '',
    hoc_travel_time: '',
    hoc_start_date: '',
    hoc_end_date: '',
    hoc_departure_time: '',
    hoc_selected_days: '',
  });

  useEffect(() => {
    setLocalFormData(formData);
    stationDataApi();
    fetchTruckRateList({ 'date': formData.existing_date });
    const dateToday = dateYMD(new Date());
    //setLocalFormData({ ...localFormData, existing_date: dateToday });
    // onFormDataChange({ ...localFormData, existing_date: dateToday });
  }, []);
  const getSuggestionValue = (suggestion) => suggestion.station_code;


  const fetchData = async () => {
    try {
      const res = await withRFSToken.post(STATIONGRID, {})
        .then(function (res) {
          // const innerData = res.data.response_data;
          // const activeInnerData = res.data.response_data.Active;
          // const transformedData = activeInnerData ? activeInnerData.map(item => ({
          //     // id: item.id,
          //     value: item.id,
          //     label: item.station_code,
          //     address: item.station_addresses,
          // })) : []; // For multiselect
          // //   console.log("🚀 ~ transformedData ~ transformedData:", transformedData)
          // setBoardPoint(transformedData); // For multiselect
          // setOffPoint(transformedData);
          // setFetchStation(innerData.Active);
          // // setSuggestionsBp(innerData.Active);
          // // setSuggestionsOffpoint(innerData.Active);
          // return activeInnerData
        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const stationDataApi = async () => {
    try {
      const res = await withRFSToken.post(STATIONGRID, {})
        .then(function (res) {
          const innerData = res.data.response_data;
          const transformData = innerData.Active ? innerData.Active.map((data) => ({
            ...data,
            value: data.id,
            label: data.station_code,
          })) : [];
          setBoardpoint(transformData);
          setOffPoint(transformData);
          if (formData.boardpoint) {
            const selectedbpAdd = transformData.find(option => option.value === formData.boardpoint);
            setBpaddress(selectedbpAdd ? selectedbpAdd.station_addresses?.map(handler => ({
              value: handler.id,
              label: `${handler.handler_name} - ${handler.address_1}`
            })) : []);
          }
          if (formData.offpoint) {
            const selectedOff = transformData.find(option => option.value === formData.offpoint);
            setOffPointAddress(selectedOff ? selectedOff.station_addresses.map(handler => ({
              value: handler.id,
              label: `${handler.handler_name} - ${handler.address_1}`
            })) : []);
          }


          if (formData.hoc_boardpoint) {
            const hoc_selectedboard = transformData.find(option => option.value === formData.hoc_boardpoint);
            hoc_setBpaddress(hoc_selectedboard ? hoc_selectedboard.station_addresses?.map(handler => ({
              value: handler.id,
              label: `${handler.handler_name} - ${handler.address_1}`
            })) : []);
          }

          if (formData.hoc_offpoint) {
            const hoc_selectedoff = transformData.find(option => option.value === formData.hoc_offpoint);
            hoc_setOffPointAddress(hoc_selectedoff ? hoc_selectedoff.station_addresses.map(handler => ({
              value: handler.id,
              label: `${handler.handler_name} - ${handler.address_1}`
            })) : []);
          }

        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const fetchTruckRateList = async (alldata) => {
    try {
      const res = await withRFSToken.post(GETSCHEDULEDTRUCKS, alldata)
        .then(function (res) {
          const innerData = res.data.response_data;
          setBookingTruckList(innerData);
        });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const onChange = (event, { newValue }) => {
    setValue(newValue);
    setShowAddButton(false);
    if (!newValue) {
      setBpaddress(null);
    } else {
      const station = suggestionsBp.find(station => getSuggestionValue(station).toLowerCase() === newValue.toLowerCase());
      if (station) {
        setBpaddress(station.station_addresses);
        setShowAddAddressButton(true);
        setShowAddButton(false);
      } else {
        setBpaddress(null);
        setShowAddAddressButton(false);
        setShowAddButton(true);
      }
    }

  };
  const onSuggestionsFetchRequested = ({ value }) => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;

    setSuggestionsBp(
      inputLength === 0
        ? []
        : fetchStation.filter(
          (fruit) => fruit.station_code.toLowerCase().slice(0, inputLength) === inputValue &&
            fruit.station_code !== (selectedOffpoint && selectedOffpoint.station_code)
        )
    );

    // setShowAddButton(inputLength > 0 && suggestionsBp.length === 0); commented 30.04.24
  };
  const onSuggestionsClearRequested = () => {
    setSuggestionsBp([]);
    setSelectedOffpoint(null); // TO CLEAN FIRST FIELD

    // setShowAddButton(false);
  };
  const renderSuggestion = (suggestion) => <div>{suggestion.station_code}</div>;
  const onSelectBpaddress = (bpadd, type) => {
    if (bpadd) {
      if (bpadd.station_addresses) {
        setBpaddress(bpadd.station_addresses);
      } else {
        setBpaddress([]);
      }
    } else {
      setBpaddress([]);
    }
    let updatedData = [];
    if (type == "New") {
      updatedData = { ...localFormData, "new_board_point": bpadd.id, "new_board_point_name": bpadd.station_code };
    } else {
      updatedData = { ...localFormData, "hoc_board_point": bpadd.id, "hoc_board_point_name": bpadd.station_code };
    }
    setLocalFormData(updatedData);
    onFormDataChange(updatedData);
  }
  const inputProps = {
    placeholder: 'Type a Stations',
    value,
    onChange: onChange,
  };
  const onChangeOffpoint = (event, { newValue }) => {
    setValueOffpoint(newValue);
    setShowAddButtonOffpoint(false);

    if (!newValue) {
      setBpaddress(null);
    } else {
      // Filter suggestionsBp based on the input value
      const station = suggestionsOffpoint.find(station => getSuggestionValueOffpoint(station).toLowerCase() === newValue.toLowerCase());
      // If a matching station is found, set bpaddress to its station_addresses data
      if (station) {
        setSelectedOffpoint(station.station_addresses);
        setShowAddAddressButton2(true);
        setShowAddButtonOffpoint(false);
        // setStationData(station);
      } else {
        setSelectedOffpoint(null); // Set bpaddress to null if no matching station is found
        setShowAddButtonOffpoint(true);
        setShowAddAddressButton2(false);
      }
    }
  };
  const onSuggestionsFetchRequestedOffpoint = ({ value }) => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;

    setSuggestionsOffpoint(
      inputLength === 0
        ? []
        : fetchStation.filter(
          (fruit) => fruit.station_code.toLowerCase().slice(0, inputLength) === inputValue &&
            fruit.station_code !== (bpaddress && bpaddress.station_code)
        )
          .filter(suggestion => suggestion.station_code !== (selectedOffpoint && selectedOffpoint.station_code))
    );
    // setShowAddButtonOffpoint(inputLength > 0 && suggestionsBp.length === 0);
  };
  const onSuggestionsClearRequestedOffpoint = () => {
    setSuggestionsOffpoint([]);
    // setBpaddress(null);
    // setShowAddButtonOffpoint(false);
  };
  const getSuggestionValueOffpoint = (suggestion) => suggestion.station_code;
  const renderSuggestionOffpoint = (suggestion) => <div>{suggestion.station_code}</div>;
  const onSelectOffpoint = (offpoint, type) => {
    if (offpoint) { setSelectedOffpoint(offpoint.station_addresses); }
    let updatedData = [];
    if (type == "New") {
      updatedData = { ...localFormData, "new_off_point": offpoint.id, "new_off_point_name": offpoint.station_code };
    } else {
      updatedData = { ...localFormData, "hoc_off_point": offpoint.id, "hoc_off_point_name": offpoint.station_code };
    }
    setLocalFormData(updatedData);
    onFormDataChange(updatedData);
    setLocalFormData(updatedData);
    onFormDataChange(updatedData);
  };
  const onAddButtonClick = (autosuggestId) => {
    // AddStation
    // setShowAddButton(true);
    setShowAddButton(false);
    setShowAddButtonOffpoint(false);
    setShowAddStation(true);
    if (autosuggestId == 'op') {
      setValueOffpoint('');
    } else {
      setValue('');
    }


  };
  const handleCloseModal = () => {
    setShowAddStation(false);
    setShowAddStationAddress(false);
  };
  const handleBPAddressChange = (event, type) => {
    const selectedValue = event.target.value;
    const selectedText = event.target.options[event.target.selectedIndex].text;
    let updatedData = [];
    if (type == "New") {
      updatedData = { ...localFormData, "new_board_address": selectedValue, "new_board_address_name": selectedText };
    } else {
      updatedData = { ...localFormData, "hoc_board_address": selectedValue, "hoc_board_address_name": selectedText };
    }
    setLocalFormData(updatedData);
    onFormDataChange(updatedData);
  };
  const handleOPAddressChange = (event, type) => {
    const selectedValue = event.target.value;
    const selectedText = event.target.options[event.target.selectedIndex].text;
    let updatedData = [];
    if (type == "New") {
      updatedData = { ...localFormData, "new_off_address": selectedValue, "new_off_address_name": selectedText };
    } else {
      updatedData = { ...localFormData, "hoc_off_address": selectedValue, "hoc_off_address_name": selectedText };
    }
    setLocalFormData(updatedData);
    onFormDataChange(updatedData);
    // setFormData({
    //   ...formData,
    //   offpoint_address: selectedValue
    // });
  };
  const [showAddStationAddress, setShowAddStationAddress] = useState(false)
  const handleAddAddressClick = (addressType, stationId) => {
    if (!stationId) {
      if (addressType == 'bp') {
        toast.error('Please select Boardpoint')
      } else {
        toast.error('Please select Offpoint')
      }
    } else {
      setStationData(stationId);
      setShowAddStationAddress(true);
      setAddressType(addressType);
    }
  }
  const handleFormOnchange = (e) => {
    const { name, value } = e.target;
    const updatedData = { ...localFormData, [name]: value };
    setLocalFormData(updatedData);
    onFormDataChange(updatedData);
  }
  const [selectedDate, setSelectedDate] = useState(false)
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const updatedData = { ...localFormData, [name]: value };
    setLocalFormData(updatedData);
    onFormDataChange(updatedData);
    fetchTruckRateList({ 'date': (e.target.value) });
    if (name == "existing_date" || name == "start_date" || name == "hoc_date") {
      setSelectedDate(value)
    }

  };
  const bookingTruckChange = (bookingtruck_id, bookingtruck_date_id, bookingtruck_no,departure_date, departure_time, board_point, off_point) => {


    setLocalFormData({
      ...localFormData,
      bookingtruck_id: bookingtruck_id,
      bookingtruck_date_id: bookingtruck_date_id,
      bookingtruck_no: bookingtruck_no,
      departure_date: departure_date,
      departure_time: departure_time,
      board_point: board_point,
      off_point: off_point,
    });
    onFormDataChange({
      ...localFormData,
      bookingtruck_id: bookingtruck_id,
      bookingtruck_date_id: bookingtruck_date_id,
      bookingtruck_no: bookingtruck_no,
      departure_date: departure_date,
      departure_time: departure_time,
      board_point: board_point,
      off_point: off_point,
    });
  };
  const handleReloadAddress = async () => {
    try {
      const res = await withRFSToken.post(STATIONGRID, {})
        .then(function (res) {
          const innerData = res.data.response_data;
          const activeInnerData = res.data.response_data.Active;
          if (selectedBoardpoint !== null) { }
          setFetchStation(innerData.Active);
          setSuggestionsBp(innerData.Active);
          setSuggestionsOffpoint(innerData.Active);
          if (addressType == 'bp') {
            if (innerData) {
              const station = innerData.Active.find(station => station.id === stationData.id)
              if (station.station_addresses) {
                setBpaddress(station.station_addresses);
              } else {
                setBpaddress([]);
              }
            } else {
              setBpaddress([]);
            }
          } else {
            if (innerData) {
              const station = innerData.Active.find(station => station.id === stationData.id)
              if (station.station_addresses) {
                setSelectedOffpoint(station.station_addresses);
              } else {
                setSelectedOffpoint([]);
              }
            } else {
              setSelectedOffpoint([]);
            }
          }

          setShowAddStation(false);
          setShowAddStationAddress(false);
          return activeInnerData
        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
    // const stationAddress = suggestionsBp.find(station => getSuggestionValue(station).toLowerCase() === fetchStation.station_code.toLowerCase());
  }
  function dateYMD(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so add 1
    const day = String(date.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  }
  const [selected, setSelected] = useState([]);

  const handleClick = (day) => {
    if (selected.includes(day)) {
      setSelected(selected.filter((d) => d !== day));
    } else {
      setSelected([...selected, day]);
    }
    const selectedDays = localFormData.selected_days.includes(day) ? localFormData.selected_days.filter(item => item !== day) : [...localFormData.selected_days, day];
    setLocalFormData({
      ...localFormData,
      selected_days: selectedDays
    });
  };
  const hoc_handleClick = (day) => {
    if (selected.includes(day)) {
      setSelected(selected.filter((d) => d !== day));
    } else {
      setSelected([...selected, day]);
    }
    const selectedDays = localFormData.selected_days.includes(day) ? localFormData.selected_days.filter(item => item !== day) : [...localFormData.selected_days, day];
    setLocalFormData({
      ...localFormData,
      hoc_selected_days: selectedDays
    });
  };
  return (
    <div>

      <h4 className='subhead'>STEP 1</h4>
      <h2>Type of Truck</h2>
      <Form>
        <div className='type_work'>
          <div className="mb-3">
            <Form.Check
              inline
              label="Booking Truck"
              name="truck_type"
              type='radio'
              id='booking_truck'
              value="B"
              checked={localFormData.truck_type === 'B'}
              onChange={handleInputChange}
            />
            <Form.Check
              inline
              label="Ad Hoc"
              name="truck_type"
              type='radio'
              id='ad-hoc'
              value="A"
              checked={localFormData.truck_type === 'A'}
              onChange={handleInputChange}
            />
          </div>
          {localFormData.truck_type == 'B' && (
            <>
              {/* {['radio'].map((type) => ( */}
              <div className="mb-2">
                <Form.Check
                  inline
                  label="Existing Bookingtruck"
                  name="bookingTruck_type"
                  type='radio'
                  value='E'
                  id="existing_booking_truck"
                  checked={localFormData.bookingTruck_type === 'E'}
                  onChange={handleInputChange}
                />
                <Form.Check
                  inline
                  label="New Bookingtruck"
                  name="bookingTruck_type"
                  type='radio'
                  value='N'
                  id="new_booking_truck"
                  checked={localFormData.bookingTruck_type === 'N'}
                  onChange={handleInputChange}
                />
              </div>
              {/* ))} */}

              {localFormData.bookingTruck_type === 'E' && (
                <>
                  <Form.Group as={Row}>
                    <Form.Label>Select Date</Form.Label>
                    <Col sm="6">
                      <Form.Control type="date" name='existing_date' value={localFormData.existing_date} onChange={handleInputChange} />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Col sm="10">
                      <Form.Label>List of Bookingtruck</Form.Label>

                      <Table striped bordered hover>
                        <thead>
                          <tr>
                            <th>Bookingtruck No</th>
                            <th>Date</th>
                            <th>Boardpoint</th>
                            <th>Offpoint</th>
                          </tr>
                        </thead>
                        <tbody>

                          {bookingTruckList?.map((value, index) => (
                            <tr key={index} onClick={() => bookingTruckChange(
                              value.bookingtruck_id,
                              value.bookingtruck_date_id,
                              value.bookingtruck_no,
                              value.departure_date,
                              value.departure_time,
                              value.board_point,
                              value.off_point,
                            )}>
                              <td>{value.bookingtruck_no}</td>
                              <td>{value.departure_date} {value.departure_time}</td>
                              <td>{value.board_point}</td>
                              <td>{value.off_point}</td>
                            </tr>
                          ))}

                        </tbody>
                      </Table>
                    </Col>
                  </Form.Group>
                </>
              )}

              {localFormData.bookingTruck_type === 'N' && (
                <>
                  <div className="mb-2">
                    <Form.Check
                      inline
                      label="Export"
                      name="booking_type"
                      type='radio'
                      id='export'
                      value='E'
                      checked={localFormData.booking_type === 'E'}
                      onChange={handleFormOnchange}
                    />

                    <Form.Check
                      inline
                      label="Import"
                      value="I"
                      name="booking_type"
                      type='radio'
                      id='import'
                      checked={localFormData.booking_type === 'I'}
                      onChange={handleFormOnchange}
                    />
                  </div>
                  {/* <Col sm="6"> */}
                  <Form.Group className="mb-2" controlId="exampleForm.ControlInput1">
                    <Form.Label>Bookingtruck No</Form.Label>
                    <Form.Control type="email" placeholder="#12134567" name='bookingtruck_no' value={localFormData.bookingtruck_no} onChange={handleFormOnchange} />
                  </Form.Group>
                  {/* </Col> */}
                  <Form.Group as={Row}>
                    <Col sm="4">
                      <Form.Label>Boardpoint <Button className='raad_adrss' onClick={() => onAddButtonClick("bp")}> + Add </Button></Form.Label>
                      <div className='autosugg'>
                        <Select
                          options={boardPoint}
                          onChange={(selected) => {
                            setSelectedBoardPointAddress(null)
                            const selectedpoint = boardPoint.find(option => option.value === selected.value);
                            setBpaddress(selectedpoint ? selectedpoint.station_addresses?.map(handler => ({
                              value: handler.id,
                              label: `${handler.handler_name} - ${handler.address_1}`
                            })) : []);
                            setSelectedBoardpoint(selected);
                            const updatedData = { ...localFormData, boardpoint: selected.value, boardpoint_name: selected.station_code, boardpoint_address: '' };
                            setLocalFormData(updatedData);
                            // onFormDataChange2(updatedData);
                            onFormDataChange(updatedData);
                          }}
                          placeholder="Boardpoint"
                          className='autoslct'
                          name="boardpoint"
                          value={boardPoint.find(option => option.id === localFormData.boardpoint)}
                        />
                      </div>
                    </Col>
                    <Col sm="4">
                      <Form.Label>Boardpoint Address <Button className='raad_adrss' onClick={() => handleAddAddressClick('bp', selectedBoardpoint)}>+ Add</Button></Form.Label> {/* > */}
                      <Select
                        options={bpaddress}
                        onChange={(selected) => {
                          const updatedData = { ...localFormData, boardpoint_address: selected.value, boardpoint_address_name: selected.label };
                          setSelectedBoardPointAddress(selected);
                          setLocalFormData(updatedData);
                          onFormDataChange(updatedData);
                        }}
                        placeholder="Address"
                        className='autoslct rfslct'
                        name="boardpoint_address"
                        isDisabled={bpaddress?.length > 0 ? false : true}
                        value={bpaddress?.length > 0 && localFormData.boardpoint_address !== ''
                          ? bpaddress?.find(option => option.value === localFormData.boardpoint_address)
                          : null}
                      />
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} className="mb-2">
                    <Col sm="4">
                      <Form.Label>Offpoint <Button className='raad_adrss' onClick={() => onAddButtonClick("op")}> + Add </Button></Form.Label>
                      {/* {console.log('rty', boardpoint)} */}
                      <div className='autosugg'>
                        <Select
                          options={offPoint}
                          onChange={(selected) => {
                            setSelectedOffPointAddress(null);
                            const selectedpoint = boardPoint.find(option => option.value === selected.value);
                            setOffPointAddress(selectedpoint ? selectedpoint.station_addresses.map(handler => ({
                              value: handler.id,
                              label: `${handler.handler_name} - ${handler.address_1}`
                            })) : []);
                            setSelectedOffpointId(selected)
                            const updatedData = { ...localFormData, offpoint: selected.value, offpoint_name: selected.station_code, offpoint_address: '' };
                            setLocalFormData(updatedData);
                            // onFormDataChange2(updatedData);
                            onFormDataChange(updatedData);
                          }}
                          placeholder="Offpoint"
                          className='autoslct'
                          name="offpoint"
                          value={offPoint.find(option => option.value === localFormData.offpoint)}
                        />
                      </div>
                    </Col>
                    <Col sm="4">
                      <Form.Label>Offpoint Address  <Button className='raad_adrss' onClick={() => handleAddAddressClick('op', selectedOffpointId)}>+ Add</Button></Form.Label> {/* > */}
                      <Select
                        options={offPointAddress}
                        onChange={(selected) => {
                          const updatedData = { ...localFormData, offpoint_address: selected.value, offpoint_address_name: selected.label };
                          setSelectedOffPointAddress(selected);
                          setLocalFormData(updatedData);
                          onFormDataChange(updatedData);
                        }}
                        placeholder="Address"
                        className='autoslct rfslct'
                        name="offpoint_address"
                        isDisabled={offPointAddress.length > 0 ? false : true}
                        value={offPointAddress.length > 0 && localFormData.offpoint_address !== ''
                          ? offPointAddress.find(option => option.value === localFormData.offpoint_address)
                          : null}
                      />
                    </Col>
                  </Form.Group>
                  {showAddStationAddress && <AddStationAddress reloadAddress={handleReloadAddress} stationId={stationData} onClose={handleCloseModal} />}
                  {showAddStation && <AddStation reloadStation={handleReloadAddress} onClose={handleCloseModal} />}
                  <hr />
                  <div className="mb-2">
                    <Form.Check
                      inline
                      label="One-Off"
                      name="trip_type"
                      type='radio'
                      id='one-off'
                      value="O"
                      checked={localFormData.trip_type === 'O'}
                      onChange={handleInputChange}
                    />
                    <Form.Check
                      inline
                      label="Frequent"
                      name="trip_type"
                      type='radio'
                      id='Frequent'
                      value="F"
                      checked={localFormData.trip_type === 'F'}
                      onChange={handleInputChange}
                    />
                  </div>
                  {localFormData.trip_type === 'O' && (
                    <>
                      <Form.Group as={Row} className='mb-2'>
                        <Col sm="6">
                          <Form.Label>Departure Date</Form.Label>
                          <Form.Control type="date" name='departure_date' value={localFormData.departure_date} onChange={handleFormOnchange} />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row}>
                        <Col sm="6">
                          <Form.Label>Departure Time</Form.Label>
                          <Form.Control type="time" name='departure_time' value={localFormData.departure_time} onChange={handleFormOnchange} />
                        </Col>
                        <Col sm="6">
                          <Form.Label>Est. Travel Time</Form.Label>
                          <Form.Control type="time" name='travel_time' value={localFormData.travel_time} onChange={handleFormOnchange} />
                        </Col>
                      </Form.Group>
                    </>
                  )}
                  {localFormData.trip_type === 'F' && (
                    <>
                      <Form.Label>Select Weekdays</Form.Label>

                      <ul className='freq_week mb-3'>
                        <li className={selected.includes(0) ? 'selected' : ''} onClick={() => handleClick(0)}>Su</li>
                        <li className={selected.includes(1) ? 'selected' : ''} onClick={() => handleClick(1)}>Mo</li>
                        <li className={selected.includes(2) ? 'selected' : ''} onClick={() => handleClick(2)}>Tu</li>
                        <li className={selected.includes(3) ? 'selected' : ''} onClick={() => handleClick(3)}>We</li>
                        <li className={selected.includes(4) ? 'selected' : ''} onClick={() => handleClick(4)}>Th</li>
                        <li className={selected.includes(5) ? 'selected' : ''} onClick={() => handleClick(5)}>Fr</li>
                        <li className={selected.includes(6) ? 'selected' : ''} onClick={() => handleClick(6)}>Sa</li>
                      </ul>

                      <Form.Group as={Row} className='mb-2'>
                        <Form.Label>Bookingtruck Start & End Date </Form.Label>
                        <Col sm="6">
                          <Form.Control type="date" name='start_date' value={localFormData.start_date} onChange={handleFormOnchange} />
                        </Col>

                        <Col sm="6">
                          <Form.Control type="date" name='end_date' value={localFormData.end_date} onChange={handleFormOnchange} />
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} className='mb-2'>

                        <Col sm="6">
                          <Form.Label>Departure Time</Form.Label>
                          <Form.Control type="time" name='departure_time' value={localFormData.departure_time} onChange={handleFormOnchange} />
                        </Col>
                        <Col sm="6">
                          <Form.Label>Est. Travel Time</Form.Label>
                          <Form.Control type="time" name='travel_time' value={localFormData.travel_time} onChange={handleFormOnchange} />
                        </Col>
                      </Form.Group>
                    </>
                  )}
                </>
              )}

            </>
          )}
          {localFormData.truck_type === 'A' && (
            <>
              {['radio'].map((type) => (
                <div key={`inline-${type}`} className="mb-2">
                  <Form.Check
                    inline
                    label="Export"
                    name="hoc_movement_type"
                    type={type}
                    id={`inline-${type}-1`}
                    value="E"
                    checked={localFormData.hoc_movement_type === 'E'}
                    onChange={handleInputChange}
                  />
                  <Form.Check
                    inline
                    label="Import"
                    name="hoc_movement_type"
                    type={type}
                    id={`inline-${type}-2`}
                    value="I"
                    checked={localFormData.hoc_movement_type === 'I'}
                    onChange={handleInputChange}
                  />
                </div>
              ))}
              <Form.Group className="mb-2" controlId="exampleForm.ControlInput1">
                <Form.Label>Bookingtruck No</Form.Label>
                <Form.Control type="email" placeholder="#12134567" name='hoc_bookingtruck_no' value={localFormData.hoc_bookingtruck_no} onChange={handleFormOnchange} />
              </Form.Group>
              <Form.Group as={Row}>
                <Col sm="4">
                  <Form.Label>Boardpoint <Button className='raad_adrss' onClick={() => onAddButtonClick("bp")}> + Add </Button></Form.Label>
                  <div className='autosugg'>
                    <Select
                      options={boardPoint}
                      onChange={(selected) => {
                        hoc_setSelectedBoardPointAddress(null)
                        const selectedpoint = boardPoint.find(option => option.value === selected.value);
                        hoc_setBpaddress(selectedpoint ? selectedpoint.station_addresses?.map(handler => ({
                          value: handler.id,
                          label: `${handler.handler_name} - ${handler.address_1}`
                        })) : []);
                        hoc_setSelectedBoardpoint(selected);
                        const updatedData = { ...localFormData, hoc_boardpoint: selected.value, hoc_boardpoint_name: selected.station_code, hoc_boardpoint_address: '' };
                        setLocalFormData(updatedData);
                        // onFormDataChange2(updatedData);
                        onFormDataChange(updatedData);
                      }}
                      placeholder="Boardpoint"
                      className='autoslct'
                      name="boardpoint"
                      value={boardPoint.find(option => option.value === localFormData.hoc_boardpoint)}
                    />
                  </div>
                </Col>
                <Col sm="4">
                  <Form.Label>Boardpoint Address <Button className='raad_adrss' onClick={() => handleAddAddressClick('bp', selectedBoardpoint)}>+ Add</Button></Form.Label> {/* > */}
                  <Select
                    options={hoc_bpaddress}
                    onChange={(selected) => {
                      const updatedData = { ...localFormData, hoc_boardpoint_address: selected.value, hoc_boardpoint_address_name: selected.label };
                      hoc_setSelectedBoardPointAddress(selected);
                      setLocalFormData(updatedData);
                      onFormDataChange(updatedData);
                    }}
                    placeholder="Address"
                    className='autoslct rfslct'
                    name="boardpoint_address"
                    isDisabled={hoc_bpaddress?.length > 0 ? false : true}
                    value={hoc_bpaddress?.length > 0 && localFormData.hoc_boardpoint_address !== ''
                      ? hoc_bpaddress?.find(option => option.value === localFormData.hoc_boardpoint_address)
                      : null}
                  />
                </Col>
              </Form.Group>

              <Form.Group as={Row} className="mb-2">
                <Col sm="4">
                  <Form.Label>Offpoint <Button className='raad_adrss' onClick={() => onAddButtonClick("op")}> + Add </Button></Form.Label>
                  {/* {console.log('rty', boardpoint)} */}
                  <div className='autosugg'>
                    <Select
                      options={offPoint}
                      onChange={(selected) => {
                        hoc_setSelectedOffPointAddress(null);
                        const selectedpoint = boardPoint.find(option => option.value === selected.value);
                        hoc_setOffPointAddress(selectedpoint ? selectedpoint.station_addresses.map(handler => ({
                          value: handler.id,
                          label: `${handler.handler_name} - ${handler.address_1}`
                        })) : []);
                        hoc_setSelectedOffpointId(selected)
                        const updatedData = { ...localFormData, hoc_offpoint: selected.value, hoc_offpoint_name: selected.station_code, hoc_offpoint_address: '' };
                        setLocalFormData(updatedData);
                        // onFormDataChange2(updatedData);
                        onFormDataChange(updatedData);
                      }}
                      placeholder="Offpoint"
                      className='autoslct'
                      name="offpoint"
                      value={offPoint.find(option => option.value === localFormData.hoc_offpoint)}
                    />
                  </div>
                </Col>
                <Col sm="4">
                  <Form.Label>Offpoint Address  <Button className='raad_adrss' onClick={() => handleAddAddressClick('op', selectedOffpointId)}>+ Add</Button></Form.Label> {/* > */}
                  <Select
                    options={hoc_offPointAddress}
                    onChange={(selected) => {
                      const updatedData = { ...localFormData, hoc_offpoint_address: selected.value, hoc_offpoint_address_name: selected.label };
                      hoc_setSelectedOffPointAddress(selected);
                      setLocalFormData(updatedData);
                      onFormDataChange(updatedData);
                    }}
                    placeholder="Address"
                    className='autoslct rfslct'
                    name="offpoint_address"
                    isDisabled={hoc_offPointAddress.length > 0 ? false : true}
                    value={hoc_offPointAddress.length > 0 && localFormData.hoc_offpoint_address !== ''
                      ? hoc_offPointAddress.find(option => option.value === localFormData.hoc_offpoint_address)
                      : null}
                  />
                </Col>
              </Form.Group>

              {/* <Form.Group as={Row}>
                <Form.Label>Date and time</Form.Label>
                <Col sm="4">
                  <Form.Control type="date" name='hoc_date' value={localFormData.hoc_date} onChange={handleInputChange} />
                </Col>
                <Col sm="4">
                  <Form.Control type="time" name='hoc_time' value={localFormData.hoc_time} onChange={handleInputChange} />
                </Col>
              </Form.Group> */}

              <hr />
              <div className="mb-2">
                <Form.Check
                  inline
                  label="One-Off"
                  name="hoc_trip_type"
                  type='radio'
                  id='one-off'
                  value="O"
                  checked={localFormData.hoc_trip_type === 'O'}
                  onChange={handleInputChange}
                />
                <Form.Check
                  inline
                  label="Frequent"
                  name="hoc_trip_type"
                  type='radio'
                  id='Frequent'
                  value="F"
                  checked={localFormData.hoc_trip_type === 'F'}
                  onChange={handleInputChange}
                />
              </div>

              {localFormData.hoc_trip_type === 'O' && (
                <>
                  <Form.Group as={Row} className='mb-2'>
                    <Col sm="6">
                      <Form.Label>Departure Date</Form.Label>
                      <Form.Control type="date" name='hoc_departure_date' value={localFormData.hoc_departure_date} onChange={handleFormOnchange} />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Col sm="6">
                      <Form.Label>Departure Time</Form.Label>
                      <Form.Control type="time" name='hoc_departure_time' value={localFormData.hoc_departure_time} onChange={handleFormOnchange} />
                    </Col>
                    <Col sm="6">
                      <Form.Label>Est. Travel Time</Form.Label>
                      <Form.Control type="time" name='hoc_travel_time' value={localFormData.hoc_travel_time} onChange={handleFormOnchange} />
                    </Col>
                  </Form.Group>
                </>
              )}
              {localFormData.hoc_trip_type === 'F' && (
                <>
                  <Form.Label>Select Weekdays</Form.Label>

                  <ul className='freq_week mb-3'>
                    <li className={selected.includes(0) ? 'selected' : ''} onClick={() => hoc_handleClick(0)}>Su</li>
                    <li className={selected.includes(1) ? 'selected' : ''} onClick={() => hoc_handleClick(1)}>Mo</li>
                    <li className={selected.includes(2) ? 'selected' : ''} onClick={() => hoc_handleClick(2)}>Tu</li>
                    <li className={selected.includes(3) ? 'selected' : ''} onClick={() => hoc_handleClick(3)}>We</li>
                    <li className={selected.includes(4) ? 'selected' : ''} onClick={() => hoc_handleClick(4)}>Th</li>
                    <li className={selected.includes(5) ? 'selected' : ''} onClick={() => hoc_handleClick(5)}>Fr</li>
                    <li className={selected.includes(6) ? 'selected' : ''} onClick={() => hoc_handleClick(6)}>Sa</li>
                  </ul>

                  <Form.Group as={Row} className='mb-2'>
                    <Form.Label>Bookingtruck Start & End Date </Form.Label>
                    <Col sm="6">
                      <Form.Control type="date" name='hoc_start_date' value={localFormData.hoc_start_date} onChange={handleFormOnchange} />
                    </Col>

                    <Col sm="6">
                      <Form.Control type="date" name='hoc_end_date' value={localFormData.hoc_end_date} onChange={handleFormOnchange} />
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} className='mb-2'>

                    <Col sm="6">
                      <Form.Label>Departure Time</Form.Label>
                      <Form.Control type="time" name='hoc_departure_time' value={localFormData.hoc_departure_time} onChange={handleFormOnchange} />
                    </Col>
                    <Col sm="6">
                      <Form.Label>Est. Travel Time</Form.Label>
                      <Form.Control type="time" name='hoc_travel_time' value={localFormData.hoc_travel_time} onChange={handleFormOnchange} />
                    </Col>
                  </Form.Group>
                </>
              )}


            </>
          )}


        </div>
      </Form>

    </div>
  )
}

const TruckOrderTwo = ({ formData, onFormDataChange2 }) => {

  const [localFormData, setLocalFormData] = useState({
    truck_no: '', truck_load: '', temperature: 'Y', drivers: '', adr: '', remarks: '', drivers_number: '', truck_inf_date: '',
    truck_inf_time: '',
  });
  useEffect(() => {
    setLocalFormData(formData);
  }, [formData]);
  const [tempShow, setTempShow] = useState();
  const TempYes = (e) => { setTempShow(true); const value = e.target.value; setLocalFormData({ ...localFormData, temperature: value }); }
  const TempNo = () => setTempShow(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const updatedData = { ...localFormData, [name]: value };
    setLocalFormData(updatedData);
    onFormDataChange2(updatedData);
  };



  return (

    <div>
      <h4 className='subhead'>STEP 2</h4>
      <h2>Truck Informaion</h2>
      <Form>
        <div className='type_work'>

          <Form.Group as={Row}>
            <Form.Label>Operational Truck No </Form.Label>
            <Col sm="8">
              <Form.Control type="text" placeholder="#123456" name='truck_no' value={localFormData.truck_no} onChange={handleInputChange} />
            </Col>
          </Form.Group>

          <Form.Group as={Row}>
            <Form.Label>Date and time</Form.Label>
            <Col sm="4">
              <Form.Control type="date" name="truck_inf_date" disabled value={localFormData.truck_inf_date} onChange={handleInputChange} />
            </Col>
            <Col sm="4">
              <Form.Control type="time" name="truck_inf_time" disabled value={localFormData.truck_inf_time} onChange={handleInputChange} />
            </Col>
          </Form.Group>
          <div>
            <Form.Label>Truck Load</Form.Label>
            {['radio'].map((type) => (
              <div key={`inline-${type}`} className="mb-2">
                <Form.Check
                  inline
                  label="FLT"
                  name="truck_load"
                  type={type}
                  id={`inline-${type}-1`}
                  value="F"
                  checked={localFormData.truck_load === 'F'}
                  onChange={handleInputChange}
                />
                <Form.Check
                  inline
                  label="LTL"
                  name="truck_load"
                  type={type}
                  id={`inline-${type}-2`}
                  value="L"
                  checked={localFormData.truck_load === 'L'}
                  onChange={handleInputChange}
                />
              </div>
            ))}
          </div>
          <div>
            <Form.Label>Temperature Controled</Form.Label>
            {['radio'].map((type) => (
              <>
                <div key={`inline-${type}`} className="mb-2">
                  <Form.Check
                    inline
                    label="YES"
                    name="temperature"
                    type={type}
                    id={`inline-${type}-1t`}
                    onChange={handleInputChange}
                    checked={localFormData.temperature === '1'}
                    value='1'
                  />
                  <Form.Check
                    inline
                    label="NO"
                    name="temperature"
                    type={type}
                    id={`inline-${type}-2t`}
                    checked={localFormData.temperature === '0'}
                    onChange={handleInputChange}
                    value='0'
                  />
                  {localFormData.temperature == 'Y' ? <span>18 - 21</span> : <span>NA</span>}
                </div>
              </>
            ))}
          </div>
          <Form.Group as={Row}>

            <Col sm="5">
              <Form.Label>Number off Drivers</Form.Label>
              {['radio'].map((type) => (
                <div key={`inline-${type}`} className="mb-2">
                  <Form.Check
                    inline
                    label="1"
                    name="drivers_number"
                    type={type}
                    id={`inline-${type}-1d`}
                    value="1"
                    checked={localFormData.drivers_number === '1'}
                    onChange={handleInputChange}
                  />
                  <Form.Check
                    inline
                    label="2"
                    name="drivers_number"
                    type={type}
                    id={`inline-${type}-2d`}
                    value="2"
                    checked={localFormData.drivers_number === '2'}
                    onChange={handleInputChange}
                  />
                </div>
              ))}
            </Col>
            <Col sm="5">
              <Form.Label>ADR Required</Form.Label>
              {['radio'].map((type) => (
                <div key={`inline-${type}`} className="mb-2">
                  <Form.Check
                    inline
                    label="YES"
                    name="adr"
                    type={type}
                    id={`inline-${type}-1a`}
                    value="1"
                    checked={localFormData.adr === '1'}
                    onChange={handleInputChange}
                  />
                  <Form.Check
                    inline
                    label="NO"
                    name="adr"
                    type={type}
                    id={`inline-${type}-2a`}
                    value="0"
                    checked={localFormData.adr === '0'}
                    onChange={handleInputChange}
                  />
                </div>
              ))}
            </Col>

          </Form.Group>

          <Form.Group as={Row}>
            <Form.Label>Remarks</Form.Label>
            <Col sm="8">
              <Form.Control type="text" placeholder="Enter Remarks" name='remarks' value={localFormData.remarks} onChange={handleInputChange} />
            </Col>
          </Form.Group>



        </div>
      </Form>

    </div>
  )
}

const TruckOrderThree = ({ formData, onFormDataChange3 }) => {
  const [rateChart, setRateChart] = useState();
  const [selectedOption, setSelectedOption] = useState('FR');
  const [FixedRate, setfixedRate] = useState('');
  const [selectedDropdownValue, setSelectedDropdownValue] = useState([]);
  const [dropdownData, setDropdownData] = useState([]);
  const [localFormData, setLocalFormData] = useState({
    rate: '',
    rateId: '',
    boardpoint: '',
    truck_load: '',
    temperature: '',
    drivers: '',
    price: '',
  });

  useEffect(() => {
    const reloadRates = async () => {
      try {
        const res = await withRFSToken.post(TRUCKERRATELIST, {})
          .then(function (res) {
            const innerData = res.data.response_data;
            setRateChart(innerData);
          });
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
    reloadRates();
    setLocalFormData(formData);
  }, []);


  const handleRadioChange = (event) => {
    setSelectedOption(event.target.value);
    const updatedData = { ...localFormData, rateType: event.target.value };
    setLocalFormData(updatedData);
    onFormDataChange3(updatedData);
  };
  const handleFixedRateChange = (event) => {
    setfixedRate(event.target.value);
    let updatedData = [];
    rateChart.forEach(element => {
      if (event.target.value == element.id) {
        updatedData = {
          ...localFormData,
          'rateId': element.id,
          'boardpoint': element.boardpoint,
          'truck_load': element.truck_load,
          'temperature': element.temperature,
          'drivers': element.drivers,
          'price': element.price,
        };
      }
    });
    setLocalFormData(updatedData);
    onFormDataChange3(updatedData);
  };
  const handleDropdownChange = (event) => {
    const updatedData = { ...localFormData, rateId: event.id };
    setLocalFormData(updatedData);
    onFormDataChange3(updatedData);
  };


  return (
    <div>
      <form>
        <h4 className='subhead'>STEP 3</h4>
        <h2>Truck Booking</h2>
        <div className='type_work'>
          <Form.Check
            inline
            label={"Fixed Rate"}
            type="radio"
            name="radioGroup"
            value={"FR"}
            checked={localFormData.rateType === "FR"}
            onChange={handleRadioChange}
          />
          <Form.Check
            inline
            label={"Free Market"}
            type="radio"
            name="radioGroup"
            value={"FM"}
            checked={localFormData.rateType === "FM"}
            onChange={handleRadioChange}
          />
          {localFormData.rateType === 'FR' && (
            <div className="plans mt-3">
              {rateChart && rateChart.map((rates, index) => (
                <>
                  <label className="plan basic-plan" htmlFor={"rate" + index}>
                    <input type="radio" name="plan" id={"rate" + index} value={rates.id} onChange={handleFixedRateChange} />
                    <div className="plan-content">
                      <ul>
                        <li><span>Boardpoint: </span> <span>{rates.boardpoint}</span></li>
                        <li><span>Truck Load: </span> <span>{rates.truck_load}</span></li>
                        <li><span>Temperature: </span> <span>{rates.temperature}</span></li>
                        <li><span>Drivers: </span> <span>{rates.drivers}</span></li>
                        <li><span>Price: </span> <span>{rates.price}</span></li>
                      </ul>
                    </div>
                  </label>
                </>
              ))}
            </div>
          )}

          {localFormData.rateType === 'FM' && (
            <div className='multis'>
              <Form.Label className='mt-2'>List of Carriers</Form.Label>
              <Form.Group as={Row}>
                <Col sm="6">
                  <Select
                    options={dropdownData}
                    onChange={handleDropdownChange}
                    placeholder="Station"
                    className='autoslct'
                    name="origin"
                    value={dropdownData.find(option => option.value === formData.repair_station)}
                  />
                </Col>
              </Form.Group>
            </div>
          )}
        </div>
      </form>
    </div>
  )
}

const TruckOrderFour = ({ formData, onFormDataChange4 }) => {


  const [files, setFiles] = useState([]);
  const fileInputRef = useRef(null);
  const [base64Files, setBase64Files] = useState([]);
  const [localFormData, setLocalFormData] = useState({
    files: ''
  });
  useEffect(() => {
    setLocalFormData(formData);
  }, []);
  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFiles = Array.from(e.dataTransfer.files);
    setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
    getBase64(droppedFiles[0]);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDeleteFile = (index) => {
    setFiles((prevFiles) => {
      const newFiles = [...prevFiles];
      newFiles.splice(index, 1);
      return newFiles;
    });

    base64Files.splice(index, 1);
    const updatedData = { ...localFormData, base64Files };
    setLocalFormData(updatedData);
  };

  const handleBrowseFiles = (e) => {
    e.preventDefault();
    fileInputRef.current.click();
  };

  function getBase64(file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
    };
    reader.onerror = function (error) {

    };
  }

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    const filesWithBase64 = [];
    selectedFiles.forEach((file) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        filesWithBase64.push({ file, base64: reader.result });
        if (filesWithBase64.length === selectedFiles.length) {
          setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => obj.file)]);
          onFormDataChange4(filesWithBase64);
          //setLocalFormData(filesWithBase64);
          setBase64Files(filesWithBase64);
          const updatedData = { ...localFormData, filesWithBase64 };
          setLocalFormData(updatedData);
        }
      };
      reader.readAsDataURL(file);
    });
  }
  return (
    <div>

      <h4 className='subhead'>STEP 4</h4>
      <h2>Adding Documents</h2>
      <Form>
        <div className='type_work'>

          <div>
            <div
              className='dropfile'
              onDrop={handleDrop}
              onDragOver={handleDragOver}
            >
              <h3>Drag and drop files here</h3>
              <p>Or</p>
              <button className='btn btn-primary drpbtn' onClick={handleBrowseFiles}>Browse Files</button>
              <span>Maximum file size 4 MB</span>
              <input
                type="file"
                ref={fileInputRef}
                style={{ display: 'none' }}
                onChange={handleFileChange}
                multiple
              />


            </div>


            <div className='uploadbox'>
              {files.map((file, index) => (
                <div key={index} className='uploadfil'>
                  {file.type.startsWith('image/') ? (
                    <img
                      src={URL.createObjectURL(file)}
                      alt="Preview"
                      style={{ maxWidth: '30px', maxHeight: '30px', marginRight: '10px' }}
                    />
                  ) : (
                    <span className='d-flex'><img src={Docmnt} className='fileimg' /> {file.name}</span>
                  )}
                  <button className='dltbtn' type="button" onClick={() => handleDeleteFile(index)}> <FontAwesomeIcon icon={faCircleXmark} color='#656565' /></button>
                </div>
              ))}

            </div>
          </div>

        </div>
      </Form>

    </div>
  )
}





export { TruckOrderOne, TruckOrderTwo, TruckOrderThree, TruckOrderFour };